/*
  Google Analytics
  set to false - output in console
  set to true - enable analytics
*/
(function() {
  if (location.hostname === "www.frontlinemarketing.com") {
    window.GA_ENABLED = true;
  } else {
    window.GA_ENABLED = false;
    console.log("Google Analytics disabled for development.");
  }
})();

// Google Analytics - initial load
export function GALoad() {
  if (GA_ENABLED) {
    (function(i, s, o, g, r, a, m) {
      i["GoogleAnalyticsObject"] = r;
      (i[r] =
        i[r] ||
        function() {
          (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
      (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(
      window,
      document,
      "script",
      "https://www.google-analytics.com/analytics.js",
      "ga",
    );
    ga("create", "UA-92909243-6", "auto");
    ga("send", "pageview");
  }
}

//  Google Analytics - about & services hash page change
export function GASendPageView() {
  if (GA_ENABLED) {
    ga("send", "pageview", {
      page: location.pathname + location.search + location.hash,
    });
  }
}

// Google Analytics - contact form changed
export function GASelectedContactForm(url) {
  if (GA_ENABLED) {
    ga("send", "event", "selected-contact-form", url);
  }
}

//  Google Analytics - contact form submitted
export function GASubmittedContactForm(form) {
  if (GA_ENABLED) {
    ga(
      "send",
      "event",
      "submitted-contact-form",
      document.getElementById("thank-you-form-link").value,
    );
  }
}

//  Google Analytics - map filter changed
export function GAMapFilterChanged(key, value) {
  if (GA_ENABLED) {
    ga("send", "event", `${key}`, `${value}`);
  }
}

//  Google Analytics - map selected location
export function GAMapSelectedLocation(location) {
  if (GA_ENABLED) {
    ga(
      "send",
      "event",
      `selectedLocation`,
      `${location.title} -
      ${location.address},
      ${location.city},
      ${location.state},
      ${location.country},
      ${location.zip}`,
    );
  }
}



// WEBPACK FOOTER //
// ./web/static/js/public/utils/analytics.js